// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZXLY","option":"styles_option__3xSld","active":"styles_active__1PUHS"};